import { Component, ElementRef, signal, ViewChild } from '@angular/core';
import { SharedDataService} from '../../Services/SharedServices/shared-data.service';
import { NemaService } from '../../Services/nema.service';
import { RgserviceService } from '../../Services/RGService/rgservice.service';
import { RgsharedserviceService } from '../../Services/RGService/rgsharedservice.service';
import { HpaServiceService } from '../../Services/HPAService/hpa-service.service';
import { HpaSharedServiceService } from '../../Services/HPAService/hpa-shared-service.service';
import { BSharedServiceService } from '../../Services/BService/b-shared-service.service';
import { BServiceService } from '../../Services/BService/b-service.service';
import { FServiceService } from '../../Services/FService/f-service.service';
import { FSharedServiceService } from '../../Services/FService/f-shared-service.service';
import { environment } from '../../../Environment/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-second-selection',
  templateUrl: './second-selection.component.html',
  styleUrl: './second-selection.component.css'
})
export class SecondSelectionComponent {
  // @ViewChild('firstCommonExpansion') firstCommonExpansion!: ElementRef;
  scrollToThirdComponent() {
    const thirdComponent = document.querySelector('app-third-selection');
    if (thirdComponent) {
      thirdComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }



  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  sharedData: any;
  seriesSelected: any;
  seriesSelectedArray: any;
  seriesSize: any;
  size: any;
  ratio: any;
  inputPower: any;
  units:any;
  speed: any;
  // series: any;
  AssetbasePath:any;
    showspinfo = false;
  showcdinfo = false;
constructor(private service:NemaService,private sharedDataService: SharedDataService, private rgService:RgserviceService, private rgSharedService:RgsharedserviceService, private hpaService:HpaServiceService, private hpaSharedService:HpaSharedServiceService, private bSharedService:BSharedServiceService, private bService:BServiceService, private fService:FServiceService, private fSharedService: FSharedServiceService, private  router: Router) {
  this.AssetbasePath = environment.assetsPath;
}
ngOnInit(): void {
 const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
  this.sharedDataService.data$.subscribe((data) => {
    this.signalStatus=true;
    this.panelOpenState = signal(this.signalStatus);
    // this.signalStatus=true;
    console.log("Data for step 2:", data);
    this.reducerData.IPPowerMech_ImpHp = data.IPPowerMech_ImpHp;
    this.reducerData.IPPowerthermal_ImpHp = data.IPPowerthermal_ImpHp;
    this.reducerData.SfBasedOnIP = data.SfBasedOnIP;
    this.reducerData.IPPowerMech_ImpRG=data.IPPowerMech_ImpRG;
    this.reducerData.IPPowerthermal_ImpRG=data.IPPowerthermal_ImpRG;
    this.reducerData.SfBasedOnIPRG=data.SfBasedOnIPRG;
    this.reducerData.HPSize = (data.HP/10).toString()+" in";
    this.reducerData.RGSize = (data.RG/10).toString()+" in";
    this.reducerData.HPASize = data.HPA+ " mm";
    this.reducerData.BSize = data.B;
    this.reducerData.FSize = data.F;
    this.reducerData.HPNoFanSize=(data.HPNOFAN/10).toString()+" in";
    this.reducerData.IPPowerMech_ImpHPNoFan=data.IPPowerMech_ImpHpNoFan;
    this.reducerData.IPPowerthermal_ImpHPNoFan=data.IPPowerthermal_ImpHpNoFan;
    this.reducerData.SfBasedOnIPHPNoFan=data.SfBasedOnIPHPNoFan;

    this.reducerData.HPANOFAN=data.HPANOFAN+" mm";
    this.reducerData.IPPowerMech_ImpHpaNoFan=data.IPPowerMech_ImpHpaNoFan;
    this.reducerData.IPPowerthermal_ImpHpaNoFan=data.IPPowerthermal_ImpHpaNoFan;
    this.reducerData.SfBasedOnIPHPANoFan=data.SfBasedOnIPHPANoFan;
    
    if(data.B){
      switch(data.B.substring(1,3)){
        case '02':
          this.reducerData.BSizeOnly = '1.33 in';
          break;
        case '03':
          this.reducerData.BSizeOnly = '1.54 in';
          break;
        case '04':
          this.reducerData.BSizeOnly = '1.75 in';
          break;
        case '05':
          this.reducerData.BSizeOnly = '1.97 in';
          break;
        case '06':
          this.reducerData.BSizeOnly = '2.38 in';
          break;
        case '08':
          this.reducerData.BSizeOnly = '2.62 in';
          break;
        case '09':
          this.reducerData.BSizeOnly = '3.00 in';
          break;
        case '10':
          this.reducerData.BSizeOnly = '3.25 in';
          break;
        case '11':
          this.reducerData.BSizeOnly = '3.54 in';
          break;
      }
      // this.reducerData.BSizeOnly = (data.B).substring(1,3);
    }
    if(data.F){
      this.reducerData.FSizeOnly = (data.F).substring(2,4) + " mm";
    }
   

    this.reducerData.IPPowerMech_ImpHPA=data.IPPowerMech_ImpHPA;
    this.reducerData.IPPowerthermal_ImpHPA=data.IPPowerthermal_ImpHPA;
    this.reducerData.SfBasedOnIPHPA=data.SfBasedOnIPHPA;

    this.reducerData.IPPowerMech_ImpB = data.IPPowerMech_ImpB;
    this.reducerData.IPPowerthermal_ImpB = data.IPPowerthermal_ImpB;
    this.reducerData.SfBasedOnIPB = data.SfBasedOnIPB;

    this.reducerData.IPPowerMech_ImpF = data.IPPowerMech_ImpF;
    this.reducerData.IPPowerthermal_ImpF = data.IPPowerthermal_ImpF;
    this.reducerData.SfBasedOnIPF = data.SfBasedOnIPF;

    this.sharedData = data;
    console.log(this.reducerData);
    let listSeries: string[] = [];
    let listSize: string[] = [];

    Object.keys(data).forEach((key) => {
      listSeries.push(key);
      listSize.push(data[key]);
    });

    this.seriesSelected = listSize;
    console.log("Selected Series: ", listSeries);
    if (listSeries.length > 0) {
      this.showReducer(listSeries);
    }
  });

  this.sharedDataService.formData$.subscribe((formData) => {
    this.ratio = formData.selectedRatio;
    this.speed = formData.selectedSpeed;
    this.inputPower = formData.selectedInputPower;
    this.units = formData.selectedUnits;
    this.reducerData.selectedInputPower = formData.selectedInputPower;
    this.reducerData.selectedServiceFactor = formData.selectedServiceFactor;
console.log("BElow are my hp form data");
 console.log(JSON.stringify(formData, null, 2));
  });

}

showReducer(classNames: string[]): void {
  debugger;
  let dataArray: string[] = ["HP","HPA","RG","F","B","HPNOFAN","HPANOFAN"];
  let classNameData: string[] = ["seriesHP", "seriesHPA", "seriesRG", "seriesF", "seriesB","seriesHPNOFAN","seriesHPANOFAN"];

  
  
  classNameData.forEach(className => {
    const elements = document.getElementsByClassName(className);
    const elementsArray = Array.from(elements) as HTMLElement[];

    // Reset display style
    elementsArray.forEach(element => {
      element.style.display = ''; // Resets to default style
    });
  });



  let notAvailableReducer = dataArray.filter(x => !classNames.includes(x));

  notAvailableReducer.forEach(className => {
    if(className=="HP"){
      className="seriesHP";
    }
    if(className=="HPA"){
      className="seriesHPA";
    }
    if(className=="RG"){
      className="seriesRG";
    }
    if(className=="F"){
      className="seriesF";
    }
    if(className=="B"){
      className="seriesB";
    }
    if(className=="HPNOFAN"){
      className="seriesHPNOFAN";
    }
    if(className=="HPANOFAN"){
      className="seriesHPANOFAN";
    }
    const elements = document.getElementsByClassName(className);
    if (elements.length > 0) {
      const elementsArray = Array.from(elements) as HTMLElement[];
    
      // Hide each element
      elementsArray.forEach(element => {
        element.style.display = 'none';
      });
    }
  });
}

onButtonClick(series: string): void {
  document.cookie = "CookiesCode=''";
 this.sharedDataService.setSeries(series.trim());
 this.sharedDataService.setSeriesData(series.trim());
 this.hpaSharedService.setSeriesData(series.trim());
 
  Object.keys(this.sharedData).forEach((key) => {
    if(series==key){
      this.size = this.sharedData[key];
      this.sharedDataService.setSize(this.size);

      return;
    }
  });
  console.log("Size = "+ this.size + " Ratio = "+this.ratio +" Speed = "+ this.speed);
  const SpecificationInput = {
    Size: this.size,
    Ratio: this.ratio,
    Speed: this.speed,
    Series: series,
    Units:this.units,
    Inputpower_Them: this.inputPower
  };
  if(series=="HP"){
    this.getHpSpecification(SpecificationInput);
    // this.scrollToFirstComponent();
  }else if(series=="RG"){
    this.getRGSpecification(SpecificationInput);
  }else if(series=="HPA"){
    this.getHPASpecification(SpecificationInput);
  }else if(series == "B"){
    this.getBSpecification(SpecificationInput);
  }else if(series == "F"){
    this.getFSpecification(SpecificationInput);
  }else if(series == "HPNOFAN"){
    this.getHpSpecification(SpecificationInput);
  }else if(series=="HPANOFAN"){
    this.getHPASpecification(SpecificationInput);
  }
  
  
}
public getHpSpecification(request: any):void{
  this.service.getHpSpecification(request).subscribe(result=>{
    this.sharedDataService.setHPSpecificationData(result.body);
    
  });
}
public getHpFanSpecification(request: any):void{
  this.service.getHpFanSpecification(request).subscribe(result=>{
    this.sharedDataService.setHPFanSpecificationData(result.body);
    
  });
}
public getRGSpecification(request: any):void{
  this.rgService.getRGSpecification(request).subscribe(result=>{
    this.rgSharedService.setSpecification(result.body);
  });
}
public getHPASpecification(request:any):void{
  this.hpaService.getSpecification(request).subscribe(result =>{
    this.hpaSharedService.setSpecification(result.body);
    console.log("Specification from HPA is here", result.body);
  });
}
public getBSpecification(request:any):void{
  this.bService.getSpecification(request).subscribe(result =>{
    this.bSharedService.setSpecification(result.body);
  });
}
public getFSpecification(request:any):void{
  this.fService.getSpecification(request).subscribe(result =>{
    this.fSharedService.setSpecification(result.body);
  });
}
reducerData={
  selectedInputPower:"",
  selectedUnits:"",
  selectedRatio:"",
  selectedSpeed:"",
  selectedDutyCycle:"",
  selectedServiceFactor:"",
  selectedOutputSpeed:"",
  IPPowerMech_ImpHp:"",
  IPPowerthermal_ImpHp:"",
  SfBasedOnIP:"",
  IPPowerMech_ImpRG:"",
  IPPowerthermal_ImpRG:"",
  SfBasedOnIPRG:"",
  HPSize:"",
  RGSize:"",
  HPASize:"",
  IPPowerMech_ImpHPA:"",
  IPPowerthermal_ImpHPA:"",
  SfBasedOnIPHPA:"",
  BSize:"",
  BSizeOnly:"",
  IPPowerMech_ImpB:"",
  IPPowerthermal_ImpB:"",
  SfBasedOnIPB:"",
  FSize:"",
  FSizeOnly:"",
  IPPowerMech_ImpF:"",
  IPPowerthermal_ImpF:"",
  SfBasedOnIPF:"",
  HPNoFanSize:"",
  IPPowerMech_ImpHPNoFan:"",
  IPPowerthermal_ImpHPNoFan:"",
  SfBasedOnIPHPNoFan:"",
  HPANOFAN:"",
  IPPowerMech_ImpHpaNoFan:"",
  IPPowerthermal_ImpHpaNoFan:"",
  SfBasedOnIPHPANoFan:""
};
}
